import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";

export type WarmupSpeed = "natural" | "fast" | "aggressive" | "auto";

interface Props {
  value: WarmupSpeed;
  onChange: (next: WarmupSpeed) => void;
  /** Radio group name so multiple pickers on a page don't clash. */
  name?: string;
}

/**
 * WarmupSpeedPicker — natural / fast / aggressive radio group + hint.
 * Single implementation, was duplicated in the Single + Zip import flows.
 */
export function WarmupSpeedPicker({ value, onChange, name = "warmup-speed" }: Props) {
  const { t } = useTranslation();
  const speeds: WarmupSpeed[] = ["auto", "natural", "fast", "aggressive"];
  return (
    <div className="flex flex-col gap-1.5 text-xs">
      <div className="flex flex-wrap gap-3">
        {speeds.map((s) => (
          <label key={s} className="flex cursor-pointer items-center gap-1.5">
            <input
              type="radio"
              name={name}
              checked={value === s}
              onChange={() => onChange(s)}
              className={cn("accent-accent")}
            />
            <span>{t(`accounts.field.warmup_speed_${s}`)}</span>
          </label>
        ))}
      </div>
      <span className="leading-snug text-fg-muted">
        {value === "auto"
          ? t("accounts.field.warmup_speed_auto_hint")
          : value === "aggressive"
            ? t("accounts.field.warmup_speed_aggressive_hint")
            : value === "fast"
              ? t("accounts.field.warmup_speed_fast_hint")
              : t("accounts.field.warmup_speed_natural_hint")}
      </span>
    </div>
  );
}
